/* The Grand Guild: cart drawer and cart page renderer.
   Renders every [data-gg-cart-root] from cart JSON on gg:cart:changed, opens the drawer on gg:cart:open,
   keeps project money and monthly money apart, manages the free gift line and the bespoke-work consent.
   Never computes discounts: amounts come from Shopify (line allocations, cart-level applications, total_price). */
(function () {
  'use strict';
  if (window.GGCart) return;
  var GGCart = window.GGCart = {};
  var cfg = function () { return window.GGConfig || {}; };
  var busyGift = false;
  var consentState = null; // null = unknown (use cart attribute), true/false = user choice this page view

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(c) { return window.GG && GG.money ? GG.money(c) : '£' + (c / 100).toFixed(2); }
  function fill(tpl, amount) { return String(tpl || '').replace('[amount]', amount); }

  function readJSON(root, sel) {
    var el = root.querySelector(sel);
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  /* ---------- Classification ---------- */
  GGCart.isGift = function (item) {
    var gid = cfg().giftVariantId;
    return (gid && Number(item.variant_id) === Number(gid)) || !!(item.properties && item.properties._gg_gift);
  };
  GGCart.isSub = function (item, meta) {
    if (/subscription/i.test(item.product_type || '')) return true;
    var ids = (meta && meta.subscriptionProducts) || [];
    return ids.indexOf(Number(item.product_id)) > -1;
  };

  /* Saving-twin lines (bundle / multi-item price): { was: base line price, label }. */
  GGCart.saving = function (it) {
    var sv = window.GG && GG.cart && GG.cart.saving ? GG.cart.saving(it.variant_id) : null;
    return sv ? { was: sv[0] * it.quantity, label: sv[1] } : null;
  };

  GGCart.compute = function (cart, meta) {
    var r = { proj: [], subs: [], gifts: [], projOriginal: 0, monthly: 0, giftFinal: 0, discounts: [], count: 0, lineDeposits: 0 };
    var byTitle = {};
    function addDisc(title, amount) {
      if (!amount) return;
      if (!byTitle[title]) { byTitle[title] = { title: title, amount: 0 }; r.discounts.push(byTitle[title]); }
      byTitle[title].amount += amount;
    }
    cart.items.forEach(function (it) {
      if (GGCart.isGift(it)) { r.gifts.push(it); r.giftFinal += it.final_line_price; return; }
      r.count += it.quantity;
      if (GGCart.isSub(it, meta)) { r.subs.push(it); r.monthly += it.final_line_price; return; }
      r.proj.push(it);
      r.lineDeposits += Math.round(it.final_line_price / 2);
      var sv = GGCart.saving(it);
      if (sv) { r.projOriginal += sv.was; addDisc(sv.label, sv.was - it.original_line_price); }
      else r.projOriginal += it.original_line_price;
      var allocs = it.line_level_discount_allocations || [];
      if (allocs.length) allocs.forEach(function (a) { addDisc((a.discount_application && a.discount_application.title) || '', a.amount); });
      else (it.discounts || []).forEach(function (d) { addDisc(d.title, d.amount); });
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) { addDisc(a.title, a.total_allocated_amount); });
    var net = cart.total_price - r.giftFinal;
    r.hasProj = r.proj.length > 0;
    r.hasSubs = r.subs.length > 0;
    r.subsOnly = !r.hasProj && r.hasSubs;
    if (r.hasProj) {
      r.projTotal = Math.max(0, net - r.monthly);
      /* Checkout charges 50% per line, rounded per line; mirror that unless an order-level discount applies. */
      r.deposit = (cart.cart_level_discount_applications || []).length ? Math.round(r.projTotal / 2) : Math.min(r.projTotal, r.lineDeposits);
      r.balance = r.projTotal - r.deposit;
      r.firstMonth = r.monthly;
    } else {
      r.projTotal = 0; r.deposit = 0; r.balance = 0;
      r.firstMonth = Math.max(0, net);
    }
    r.dueToday = r.deposit + r.firstMonth;
    r.giftBasis = r.projOriginal + r.monthly;
    return r;
  };

  /* ---------- Rendering (mirrors snippets/gg-cart-body.liquid) ---------- */
  function lineTier(it) {
    var parts = [];
    if (it.variant_title && it.variant_title !== 'Default Title') parts.push(it.variant_title);
    if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) parts.push(it.selling_plan_allocation.selling_plan.name);
    return parts.join(', ');
  }
  function row(label, value, cls) {
    return '<div class="gg-cart__row' + (cls ? ' ' + cls : '') + '"><span>' + label + '</span><span class="gg-cart__val">' + value + '</span></div>';
  }

  GGCart.render = function (root, cart) {
    var L = readJSON(root, '[data-gg-cart-labels]');
    var meta = readJSON(root, '[data-gg-cart-meta]');
    var host = root.querySelector('[data-gg-cart-view]');
    if (!host) return;
    var c = GGCart.compute(cart, meta);
    var thr = Number(cfg().giftThreshold || 0);
    var h = '';

    if (!c.count) {
      h += '<div class="gg-cart__empty"><p class="gg-cart__empty-text">' + esc(L.empty) + '</p>';
      h += '<a class="gg-btn gg-btn--red gg-cart__empty-btn" href="' + esc(L.emptyHref) + '"' + (root.hasAttribute('data-gg-cart-drawer') ? ' data-gg-close-cart' : '') + '>' + esc(L.emptyCta) + '</a></div>';
    } else {
      h += '<ul class="gg-cart__lines" role="list">';
      cart.items.forEach(function (it) {
        var gift = GGCart.isGift(it), sub = !gift && GGCart.isSub(it, meta);
        var price = gift ? esc(L.free) : money(it.final_line_price) + (sub ? esc(L.perMonth) : '');
        var tier = lineTier(it);
        h += '<li class="gg-cart__line' + (gift ? ' gg-cart__line--gift' : '') + '">';
        h += '<div class="gg-cart__line-main"><a class="gg-cart__line-title" href="' + esc(GGCart.saving(it) ? '/products/' + String(it.handle).replace(/-saving$/, '') : it.url) + '">' + esc(it.product_title) + '</a>';
        if (tier) h += '<div class="gg-cart__line-tier">' + esc(tier) + (it.quantity > 1 ? ' · ' + esc(L.qty) + ' ' + it.quantity : '') + '</div>';
        else if (it.quantity > 1) h += '<div class="gg-cart__line-tier">' + esc(L.qty) + ' ' + it.quantity + '</div>';
        h += '</div><div class="gg-cart__line-side">';
        var svl = !gift && !sub ? GGCart.saving(it) : null, was = svl ? svl.was : it.original_line_price;
        if (!gift && was > it.final_line_price && !sub) h += '<s class="gg-cart__was">' + money(was) + '</s> ';
        h += '<div class="gg-cart__line-price">' + price + '</div>';
        if (!gift) h += '<button type="button" class="gg-cart__remove" data-gg-cart-remove="' + esc(it.key) + '">' + esc(L.remove) + '<span class="gg-visually-hidden"> ' + esc(it.product_title) + '</span></button>';
        h += '</div></li>';
      });
      h += '</ul>';

      if (thr > 0) {
        if (c.giftBasis >= thr) {
          h += '<div class="gg-cart__gift gg-cart__gift--on"><svg class="gg-cart__gift-ic" aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="13" rx="2"/><path d="M3 12h18"/><path d="M12 8v13"/><path d="M12 8S10.5 3 8 3a2.5 2.5 0 0 0 0 5z"/><path d="M12 8s1.5-5 4-5a2.5 2.5 0 0 1 0 5z"/></svg>';
          h += '<div><div class="gg-cart__gift-h">' + esc(L.giftAdded) + '</div><div class="gg-cart__gift-p">' + esc(L.giftText) + '</div></div></div>';
        } else {
          var pct = Math.min(100, Math.round(c.giftBasis / thr * 100));
          h += '<div class="gg-cart__gift"><div class="gg-cart__gift-h">' + esc(fill(L.giftNudge, money(thr - c.giftBasis))) + '</div>';
          h += '<div class="gg-cart__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="' + esc(L.giftProgress) + '"><span style="width:' + pct + '%"></span></div>';
          h += '<div class="gg-cart__gift-p">' + esc(L.giftPending) + '</div></div>';
        }
      }

      h += '<div class="gg-cart__sum">';
      if (c.hasProj) {
        h += row(esc(L.projects), money(c.projOriginal), 'gg-cart__row--muted');
        c.discounts.forEach(function (d) { h += row(esc(d.title || L.discount), '−' + money(d.amount), 'gg-cart__row--disc'); });
        h += row(esc(L.projectTotal), money(c.projTotal), 'gg-cart__row--muted');
        if (c.hasSubs) {
          h += row(esc(L.deposit), money(c.deposit), 'gg-cart__row--muted');
          h += row(esc(L.firstMonth), money(c.firstMonth), 'gg-cart__row--muted');
        }
      } else {
        c.discounts.forEach(function (d) { h += row(esc(d.title || L.discount), '−' + money(d.amount), 'gg-cart__row--disc'); });
      }
      var dueLabel = c.subsOnly ? L.dueSubs : (c.hasSubs ? L.dueMixed : L.dueDeposit);
      h += row(esc(dueLabel), money(c.dueToday), 'gg-cart__row--due');
      if (c.hasProj) h += row(esc(L.balance), money(c.balance), 'gg-cart__row--small');
      if (c.hasSubs) {
        h += '<div class="gg-cart__monthly"><div class="gg-cart__monthly-h"><span>' + esc(c.subsOnly ? L.monthlySubs : L.monthlyMixed) + '</span><span>' + money(c.monthly) + esc(L.perMonth) + '</span></div><ul class="gg-cart__monthly-list" role="list">';
        c.subs.forEach(function (it) {
          var t = lineTier(it);
          h += '<li><span>' + esc(it.product_title) + (t ? ' · ' + esc(t) : '') + '</span><span>' + money(it.final_line_price) + esc(L.perMonth) + '</span></li>';
        });
        h += '</ul>' + (L.subNote ? '<p class="gg-cart__monthly-note">' + esc(L.subNote) + '</p>' : '') + '</div>';
      }
      if (c.hasProj && L.projectNote) h += '<p class="gg-cart__note">' + esc(L.projectNote) + '</p>';
      h += '</div>';

      var consented = consentState === null ? !!(cart.attributes && cart.attributes[L.consentAttr]) : consentState;
      var cid = root.getAttribute('data-gg-cart-uid') + '-consent';
      var btnLabel = (c.subsOnly ? L.ctaSubs : (c.hasSubs ? L.ctaMixed : L.ctaDeposit)) + ' · ' + money(c.dueToday);
      h += '<form class="gg-cart__form" action="' + esc(L.cartUrl) + '" method="post" data-gg-cart-form>';
      h += '<div class="gg-cart__consent"><input type="checkbox" id="' + cid + '" name="attributes[' + esc(L.consentAttr) + ']" value="' + esc(L.consentValue) + '" required data-gg-cart-consent' + (consented ? ' checked' : '') + ' aria-describedby="' + cid + '-err">';
      h += '<label for="' + cid + '">' + esc(L.consent) + '</label></div>';
      h += '<p class="gg-cart__err" id="' + cid + '-err" data-gg-cart-err hidden>' + esc(L.consentError) + '</p>';
      h += '<button type="submit" name="checkout" class="gg-btn gg-btn--red gg-btn--block gg-cart__cta" data-gg-cart-checkout' + (consented ? '' : ' aria-disabled="true"') + '>' + esc(btnLabel) + '</button>';
      h += '</form>';
      h += '<p class="gg-cart__trust">' + esc(L.trust) + '<br><a href="' + esc(L.financingHref) + '">' + esc(L.financing) + '</a> <a class="gg-cart__contact" href="' + esc(L.tel) + '" data-gg-contact><span data-gg-contact-label>' + esc(L.callLabel) + '</span></a></p>';
    }
    host.innerHTML = h;
    document.querySelectorAll('[data-gg-cart-n]').forEach(function (n) { n.textContent = c.count; });
    if (window.GG && GG.contact) GG.contact();
  };

  /* ---------- Free gift line ---------- */
  function syncGift(cart) {
    var gid = cfg().giftVariantId, thr = Number(cfg().giftThreshold || 0);
    if (!gid || !thr || busyGift || !window.GG) return;
    var roots = document.querySelectorAll('[data-gg-cart-root]');
    var meta = roots.length ? readJSON(roots[0], '[data-gg-cart-meta]') : {};
    var c = GGCart.compute(cart, meta);
    var line = null;
    cart.items.forEach(function (it) { if (Number(it.variant_id) === Number(gid)) line = it; });
    var want = c.count > 0 && c.giftBasis >= thr;
    var p = null;
    if (want && !line) p = GG.cart.add([{ id: Number(gid), quantity: 1, properties: { _gg_gift: '1' } }], { open: false });
    else if (!want && line) p = GG.cart.change(line.key, 0);
    else if (want && line && line.quantity > 1) p = GG.cart.change(line.key, 1);
    if (p) { busyGift = true; p.catch(function () {}).then(function () { busyGift = false; }); }
  }

  /* ---------- Events ---------- */
  function renderAll(cart) {
    document.querySelectorAll('[data-gg-cart-root]').forEach(function (r) { GGCart.render(r, cart); });
  }
  document.addEventListener('gg:cart:changed', function (e) { if (e.detail) { renderAll(e.detail); syncGift(e.detail); } });
  document.addEventListener('gg:cart:open', function () {
    var d = document.getElementById('gg-cart-drawer');
    if (d && window.GG && !d.classList.contains('is-open')) GG.dialog.open(d);
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-gg-cart-remove]');
    if (rm && window.GG) {
      e.preventDefault();
      var root = rm.closest('[data-gg-cart-root]');
      rm.disabled = true;
      GG.cart.change(rm.getAttribute('data-gg-cart-remove'), 0).then(function () {
        var t = root && (root.querySelector('[data-gg-cart-remove]') || root.querySelector('a, button'));
        var panel = root && root.closest('[role=dialog]');
        if (t) t.focus(); else if (panel) panel.focus();
      }).catch(function () { rm.disabled = false; });
      return;
    }
    var shop = e.target.closest('[data-gg-close-cart]');
    if (shop && window.GG) {
      var d = document.getElementById('gg-cart-drawer');
      if (d && d.classList.contains('is-open')) GG.dialog.close(d);
    }
    var co = e.target.closest('[data-gg-cart-checkout]');
    if (co && co.getAttribute('aria-disabled') === 'true') {
      e.preventDefault();
      var f = co.closest('form'), err = f.querySelector('[data-gg-cart-err]'), box = f.querySelector('[data-gg-cart-consent]');
      if (err) err.hidden = false;
      if (box) box.focus();
    }
  });
  document.addEventListener('change', function (e) {
    var box = e.target.closest('[data-gg-cart-consent]');
    if (!box) return;
    consentState = box.checked;
    document.querySelectorAll('[data-gg-cart-consent]').forEach(function (b) {
      b.checked = box.checked;
      var f = b.closest('form'), btn = f.querySelector('[data-gg-cart-checkout]'), err = f.querySelector('[data-gg-cart-err]');
      if (box.checked) { btn.removeAttribute('aria-disabled'); if (err) err.hidden = true; }
      else btn.setAttribute('aria-disabled', 'true');
    });
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-gg-cart-form]');
    if (!f) return;
    e.preventDefault();
    var box = f.querySelector('[data-gg-cart-consent]'), btn = f.querySelector('[data-gg-cart-checkout]'), err = f.querySelector('[data-gg-cart-err]');
    if (!box.checked) { if (err) err.hidden = false; box.focus(); return; }
    var root = f.closest('[data-gg-cart-root]'), L = readJSON(root, '[data-gg-cart-labels]');
    var attrs = {}; attrs[L.consentAttr] = L.consentValue + ' ' + new Date().toISOString();
    btn.setAttribute('aria-disabled', 'true');
    var go = function () { window.location.href = L.checkoutUrl || '/checkout'; };
    if (window.GG && GG.cart) GG.cart.update({ attributes: attrs }).then(go, go); else go();
  });

  /* Initial render from the cart JSON printed by Liquid (server markup is already in place; this attaches state). */
  function boot() {
    var src = document.querySelector('[data-gg-cart-initial]');
    if (!src) return;
    try { var cart = JSON.parse(src.textContent); renderAll(cart); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
